import styled, { css } from 'styled-components';

import { StyledSkipLinks, defaultThemeProp } from '@pega/cosmos-react-core';

export const StyledSkipLinksWrapper = styled.div(
  ({
    theme: {
      base: { spacing }
    }
  }) => {
    return css`
      ${StyledSkipLinks} {
        &:not(:focus-within) {
          clip: unset;
          height: auto;
          padding: ${spacing};
          width: auto;
        }
      }
    `;
  }
);

StyledSkipLinksWrapper.defaultProps = defaultThemeProp;
